import {Empty, Spin} from 'antd';

import {PageCard} from '../../../../../../layout/page-card/page-card';
import {useLocale} from '../../../../../../provider/locale/locale-hook';
import {useAiMonitoringBrandAnalysis} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-hook';
import {
    AiMonitoringRunType,
    AiMonitoringScorePointType,
} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';
import {RecommendationsBlock} from '../recommendations/recommendations-block';

import {AnalysisDynamicsChart} from './analysis-dynamics-chart';
import {MetricsHero} from './metrics-hero';
import {PositioningBlock} from './positioning-block';
import {TonalityAspects} from './tonality-aspects';
import {VisibilitySignals} from './visibility-signals';

type PropsType = {
    brandId: number;
    run: AiMonitoringRunType;
    currentRunId: string | null;
    series: Array<AiMonitoringScorePointType>;
};

export function BrandAnalysisTab(props: PropsType): JSX.Element {
    const {brandId, run, currentRunId, series} = props;
    const {getLocalizedString} = useLocale();

    const {data: analysis, isLoading} = useAiMonitoringBrandAnalysis(brandId, currentRunId);

    return (
        <>
            <PageCard>
                <MetricsHero analysis={analysis} run={run} />
            </PageCard>

            {isLoading && !analysis ? (
                <PageCard>
                    <Spin />
                </PageCard>
            ) : analysis ? (
                <>
                    <PageCard>
                        <VisibilitySignals analysis={analysis} />
                    </PageCard>
                    <PageCard>
                        <TonalityAspects analysis={analysis} />
                    </PageCard>
                    <PageCard>
                        <PositioningBlock analysis={analysis} />
                    </PageCard>
                </>
            ) : (
                <PageCard>
                    <Empty description={getLocalizedString('AI_BRAND_MONITORING__ANALYSIS__NO_DATA')} />
                </PageCard>
            )}

            <PageCard>
                <RecommendationsBlock brandId={brandId} runId={currentRunId} />
            </PageCard>

            <PageCard>
                <AnalysisDynamicsChart series={series} />
            </PageCard>
        </>
    );
}
